module.exports = __webpack_public_path__ + "static/media/ins6.b17d8a38.jpg";